"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Carousel_styled_exports = {};
__export(Carousel_styled_exports, {
  StyledContainer: () => StyledContainer,
  StyledIconButton: () => StyledIconButton,
  StyledSlide: () => StyledSlide,
  StyledSlidesContainer: () => StyledSlidesContainer
});
module.exports = __toCommonJS(Carousel_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import__ = require("./..");
var import_mixins = require("../../../themes/mixins");
var import_types = require("./types");
var getSlideBackgroundColor = function getSlideBackgroundColor2(theme, darkMode, isCurrentSlide) {
  if (isCurrentSlide) {
    return darkMode ? theme.colors.white : theme.colors.n[100];
  }
  return theme.colors.transparent.base;
};
var getSlideMargin = function getSlideMargin2(theme, variant) {
  if (variant === import_types.variants.large) {
    return "".concat(theme.measurements.zero, " ").concat(theme.measurements.extraLarge);
  }
  return "".concat(theme.measurements.zero, " ").concat(theme.measurements.extraSmall);
};
var getBoxShadow = function getBoxShadow2(theme, darkMode) {
  var overlayColor = darkMode ? theme.colors.n[100] : theme.colors.white;
  var outlineColor = darkMode ? theme.colors.beige[140] : theme.colors.beige[180];
  return "".concat(overlayColor, " 0px 0px 0px 2px, ").concat(outlineColor, " 0px 0px 0px 3px");
};
var getSlideWidthAndHeight = function getSlideWidthAndHeight2(variant) {
  switch (variant) {
    case import_types.variants.smallHorizontal:
      return (0, import_styled_components.css)(["width:12px;height:12px;"]);
    case import_types.variants.smallVertical:
      return (0, import_styled_components.css)(["width:12px;height:12px;"]);
    default:
      return (0, import_styled_components.css)(["width:calc(100% - 8px);min-width:12px;margin:0px 4px;height:12px;"]);
  }
};
var StyledContainer = import_styled_components.default.div.withConfig({
  displayName: "Carouselstyled__StyledContainer",
  componentId: "sc-1n6mps5-0"
})(function(_ref) {
  var _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? import_types.variants.large : _ref$variant, _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width;
  return (0, import_styled_components.css)(["display:", ";flex-flow:", ";align-items:center;justify-content:center;width:", ";"], variant === import_types.variants.large ? "flex" : "inline-flex", variant === import_types.variants.smallVertical ? "column" : "row", variant === import_types.variants.large ? width : "auto");
});
var StyledIconButton = (0, import_styled_components.default)(import__.IconButton).withConfig({
  displayName: "Carouselstyled__StyledIconButton",
  componentId: "sc-1n6mps5-1"
})(function(_ref2) {
  var theme = _ref2.theme, _ref2$darkMode = _ref2.darkMode, darkMode = _ref2$darkMode === void 0 ? false : _ref2$darkMode, _ref2$variant = _ref2.variant, variant = _ref2$variant === void 0 ? "large" : _ref2$variant, _ref2$color = _ref2.color, color = _ref2$color === void 0 ? theme.colors.pr.base : _ref2$color;
  return (0, import_styled_components.css)(["width:40px;height:40px;color:", ";background:transparent;margin:", ";&:hover{border:1px solid ", ";background:", ";i{color:", ";}}&:focus{background:'transparent';}&:active{border:1px solid ", ";background:", ";i{color:", ";}}&[disabled]{color:", ";&:focus,&:active,&:hover{border:0;background:transparent;i{color:", ";}}}"], darkMode ? theme.colors.white : color, variant === import_types.variants.smallVertical ? "".concat(theme.measurements.medium, " 0px") : "0px ".concat(theme.measurements.medium), darkMode ? "transparent" : theme.colors.beige[180], darkMode ? "transparent" : theme.colors.beige["40"], darkMode ? theme.colors.white : color, darkMode ? theme.colors.white : theme.colors.black, darkMode ? theme.colors.n[80] : theme.colors.beige["40"], darkMode ? theme.colors.white : color, darkMode ? theme.colors.n[30] : theme.colors.n[60], darkMode ? theme.colors.n[30] : theme.colors.n[60]);
});
var StyledSlidesContainer = import_styled_components.default.ul.withConfig({
  displayName: "Carouselstyled__StyledSlidesContainer",
  componentId: "sc-1n6mps5-2"
})(function(_ref3) {
  var theme = _ref3.theme, _ref3$variant = _ref3.variant, variant = _ref3$variant === void 0 ? import_types.variants.large : _ref3$variant;
  return (0, import_styled_components.css)(["display:flex;flex-direction:", ";align-items:center;justify-content:center;margin:", ";padding:", ";box-sizing:border-box;flex-grow:1;list-style:none;& > li.tile{flex-grow:1;margin:", ";", ";}"], variant === import_types.variants.smallVertical ? "column" : "row", theme.measurements.zero, theme.measurements.zero, theme.measurements.zero, (0, import_mixins.withPadding)("zero"));
});
var StyledSlide = import_styled_components.default.button.withConfig({
  displayName: "Carouselstyled__StyledSlide",
  componentId: "sc-1n6mps5-3"
})(function(_ref4) {
  var theme = _ref4.theme, _ref4$isCurrentSlide = _ref4.isCurrentSlide, isCurrentSlide = _ref4$isCurrentSlide === void 0 ? false : _ref4$isCurrentSlide, _ref4$variant = _ref4.variant, variant = _ref4$variant === void 0 ? import_types.variants.large : _ref4$variant, _ref4$darkMode = _ref4.darkMode, darkMode = _ref4$darkMode === void 0 ? false : _ref4$darkMode;
  return (0, import_styled_components.css)(["display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;background-color:transparent;width:", ";height:40px;border:none;margin:", ";padding:", ";&::after{content:'';", ";box-sizing:border-box;border:", " solid ", ";border-radius:32px;background-color:", ";}&:hover{&::after{border-width:", ";border-color:", ";}}&:focus,&:focus-visible{outline:none;&::after{border-width:", ";border-color:", ";box-shadow:", ";}}&:active{&::after{border:", " solid ", ";background-color:", ";box-shadow:none;}}"], variant === import_types.variants.large ? "calc(100% - 32px)" : "40px", getSlideMargin(theme, variant), theme.measurements.zero, getSlideWidthAndHeight(variant), theme.measurements.extraExtraSmall, darkMode ? theme.colors.beige[140] : theme.colors.black, getSlideBackgroundColor(theme, darkMode, isCurrentSlide), theme.measurements.extraSmall, darkMode ? theme.colors.white : theme.colors.black, theme.measurements.extraSmall, darkMode ? theme.colors.white : theme.colors.n[100], getBoxShadow(theme, darkMode), theme.measurements.extraExtraSmall, darkMode ? theme.colors.beige[140] : theme.colors.n[100], darkMode ? theme.colors.n[80] : theme.colors.beige[40]);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledContainer,
  StyledIconButton,
  StyledSlide,
  StyledSlidesContainer
});
//# sourceMappingURL=Carousel.styled.js.map